import { StyleSheet, type GestureResponderEvent } from 'react-native';
import { Icon, TouchableRipple } from 'react-native-paper';

import { colorPrimary } from '@/theme/colorPrimary';
import { rippleOnSurface } from '@/theme';

const ICON_SIZE = 24;
const TOUCH_TARGET = 48;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    borderRadius: TOUCH_TARGET / 2,
    height: TOUCH_TARGET,
    justifyContent: 'center',
    overflow: 'hidden',
    width: TOUCH_TARGET,
  },
});

interface AppbarBackButtonProps {
  readonly onPress: (e: GestureResponderEvent) => void;
  readonly color?: string;
  readonly testID?: string;
  readonly variant?: 'default' | 'dark';
}

export const AppbarBackButton = ({
  onPress,
  color,
  testID,
  variant = 'default',
}: AppbarBackButtonProps) => {
  const resolvedColor = color ?? (variant === 'dark' ? colorPrimary.nl0 : undefined);

  return (
    <TouchableRipple
      onPress={onPress}
      rippleColor={rippleOnSurface}
      style={styles.container}
      accessibilityRole="button"
      accessibilityLabel="Back"
      testID={testID}>
      <Icon source="arrow-left" size={ICON_SIZE} color={resolvedColor} />
    </TouchableRipple>
  );
};
